/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from "react";
import labels from "./errorLabels";
import ErrorHandler from "./errorHandler";

const { COMP_ERROR }: any = labels;

function ErrorBoundary({ children }: any) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const errorHandler = (error: any) => {
      console.log(error);
      setHasError(true);
    };

    window.addEventListener("error", errorHandler);
    return () => {
      window.removeEventListener("error", errorHandler);
    };
  }, []);

  if (hasError) {
    return <ErrorHandler errorCase={COMP_ERROR} />;
  }

  return children;
}

export default ErrorBoundary;
